var map = {
	"./Care.png": "4127",
	"./Collaborate.png": "40a8",
	"./LongAdmin.png": "d1bb",
	"./LongAdmin1.jfif": "e0a5",
	"./LongAdmin22.jpg": "2ae4",
	"./Privacy.png": "7453",
	"./Slider.jpg": "1f1aa",
	"./Slider.webp": "398d",
	"./SliderAr.jpg": "5b68",
	"./appointment.png": "48e5",
	"./arrowLeft.png": "e6ac",
	"./arrowRight.png": "36f9",
	"./avoid.png": "f3d2",
	"./avoid1.png": "0b0a",
	"./avoid2.png": "2222",
	"./blueBar.png": "4d39",
	"./blueBar.webp": "57c5",
	"./call.png": "feb4",
	"./certificate.jpg": "9c03",
	"./certificateSelected.jpg": "27cb",
	"./check.png": "a0a2",
	"./clock.png": "31f8",
	"./consultants.png": "a092",
	"./consultants1 (2).png": "8a9c",
	"./consultants1.png": "10f0",
	"./doctor.png": "c8d7",
	"./doctors.png": "c059",
	"./dollar.png": "96ff",
	"./face.png": "e2b5",
	"./fit.png": "0aca",
	"./flight.png": "fd69",
	"./footer.png": "0192",
	"./footer.webp": "3518",
	"./hair.png": "f8b3",
	"./headBg.png": "e7b9",
	"./hospital.png": "516b",
	"./hotel.png": "6a4a",
	"./imgslid.png": "76f6",
	"./immediate.png": "909d",
	"./immediate1.png": "f736",
	"./immediate2.png": "0f66",
	"./money.jpg": "ae43",
	"./moneySelected.jpg": "2ed7",
	"./onlineAppointments.png": "6085",
	"./onlineSite.png": "52ef",
	"./packages.png": "cfec",
	"./shape.png": "efd8",
	"./shape.webp": "174b",
	"./surface.png": "2fb4",
	"./surgeries.png": "646c",
	"./surgery.png": "fc13",
	"./time.jpg": "d697",
	"./timeSelected.jpg": "d150",
	"./transfer.png": "360d",
	"./visa.png": "2646"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e46";